
(function(){
  var HANDLE = 'purrycraft';
  function status(msg){
    var el = document.querySelector('.buy-status');
    if(el) el.textContent = msg;
  }
  function add(btn){
    var label = btn.innerHTML;
    btn.setAttribute('aria-busy','true');
    fetch('/products/' + HANDLE + '.js', {credentials:'same-origin'})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(p){
        var v = p.variants.filter(function(x){return x.available;})[0] || p.variants[0];
        if(!v) throw 0;
        return fetch('/cart/add.js', {method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:v.id, quantity:1}]})});
      })
      .then(function(r){ if(!r.ok) throw 0; window.location.href = '/cart'; })
      .catch(function(){
        btn.removeAttribute('aria-busy');
        btn.innerHTML = label;
        status('Open this page in the store to add the pattern to your cart.');
      });
  }
  document.querySelectorAll('[data-buy]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); add(btn); });
  });
})();
